export default {
  canningProcesses: [],
  canningProcess: undefined,
};
